<template>
	<div id="sContent">
		<div id="lbimg">
		  	<div style="width: 100%;height: 100%;object-fit: cover;"><img style="width: 100%;height: 100%;" src="../assets/img/tout/xueshu.jpg"></div>
		</div>
	    <div id="headerNave">
	    	<router-link tag="div" :to="{path:'/academic/learning'}">学术工作</router-link>
	    	<router-link tag="div" :to="{path:'/academic/wprotect'}">文物保护</router-link>
	    </div>
	    <div id="hr"></div>
	    <div id="sections">
	    	<div id="sects">
	    		<router-view></router-view>
	    	</div>
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				loading: false,
				tableData: []
			}
		},
		mounted(){
			if(location.href.indexOf("#reloaded")==-1){
		        location.href=location.href+"#reloaded";
		        location.reload();
		    };
			this.handleSearch();
		},
		methods:{
			handleSearch(){
				this.search();
		        let eWidth = document.body.clientWidth;
	    		document.getElementById("sContent").style.width = eWidth + "px";
	    		document.getElementById("lbimg").style.width = eWidth + "px";
	    		document.getElementById("lbimg").style.height = eWidth*0.35 + "px";
	    		document.getElementById("hCarousel").style.width = eWidth + "px";
	    		document.getElementById("hCarousel").style.height = eWidth*0.35 + "px";
		    },
		    search:function(){
	  			let that = this;
				this.HOST = 'http://www.qhmuseum.cn/qhm-webapi';
	  			let url = this.HOST + '/socialimg/getCarouselList'
	  			that.loading = true;
	  			this.$axios.post(url).then(function(result){
	  				let cData = result.data;
	  				if(cData && cData.data){
	  					that.tableData = cData.data;
	  				}
	  			}).catch(function(error){
	  				console.log(err);
	  			})
	  		}
		}
	}
</script>

<style scoped>
	#headerNave{
		height: 60px;
		line-height: 60px;
		margin: 0 auto;
		width: 400px;
	}
	#headerNave>div{
		float: left;
		width: 200px;
		cursor: pointer;
	}
	#headerNave>div:hover{
		color: #FF4500;
	}
	#hr{
		border-bottom: 1px solid #dedede;
		width: 100%;
	}
	#sections{
		width: 100%;
	}
	#sects{
		width: 90%;
		margin-left: 5%;
		margin-right: 5%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/academic.vue